import { types } from "./chavesCertificado.actions";
import { Reducer } from "../../services/reducer.factory";
import storage from "../../services/stoage.service";

const initialState = {
  id: "chavesCertificado",
  columns: [],
  currentRecord: {
    oid: ""
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false
};

const reducer = new Reducer(initialState, types);

export function CRUDChavesCertificadoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels("movimentocaixa");
  }
  state = reducer.execute(state, action);
  return execute(state, action);
}

function execute(state, action) {
  return state;
}
